import { getPromoBanner } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/__internal__/getPromoBanner";
import { IMP_TO_PROMO_BANNER_MAP } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/__internal__/siteBannersConsts";
import { PromoBannerType } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { FeatureName } from "@faire/web-api--source/indigofair/data/FeatureName";
export var mapConductorToPromoBanners = function(featureName, conductorSduiViewLayout) {
    var bannerMap = new Map();
    var getPromoBannerTypeFromFeatureName = function() {
        switch(featureName){
            case FeatureName.FIRST_ORDER_INCENTIVE:
                return PromoBannerType.FIRST_ORDER_INCENTIVE;
            default:
                return PromoBannerType.BANNER_TYPE_UNKNOWN;
        }
    };
    // For now, we only have FOI banner. We will need to adjust this when we receivee array of banners
    bannerMap.set(getPromoBannerTypeFromFeatureName(), conductorSduiViewLayout);
    return bannerMap;
};
export var mapImpToPromoBanners = function(bannersArray) {
    var bannerMap = new Map();
    bannersArray === null || bannersArray === void 0 ? void 0 : bannersArray.forEach(function(banner) {
        var _banner_mobile_and_above;
        var campaignName = (_banner_mobile_and_above = banner.mobile_and_above) === null || _banner_mobile_and_above === void 0 ? void 0 : _banner_mobile_and_above.campaign_name;
        var _IMP_TO_PROMO_BANNER_MAP_campaignName;
        var bannerType = (_IMP_TO_PROMO_BANNER_MAP_campaignName = IMP_TO_PROMO_BANNER_MAP[campaignName]) !== null && _IMP_TO_PROMO_BANNER_MAP_campaignName !== void 0 ? _IMP_TO_PROMO_BANNER_MAP_campaignName : PromoBannerType.BANNER_TYPE_UNKNOWN;
        bannerMap.set(bannerType, banner);
    });
    return bannerMap;
};
export var mapPromoBanners = function(banners) {
    var bannerMap = new Map();
    banners === null || banners === void 0 ? void 0 : banners.forEach(function(bannerType) {
        bannerMap.set(bannerType, getPromoBanner(bannerType));
    });
    return bannerMap;
};
